module.exports = __webpack_public_path__ + "img/news1.e0ea7a1c.png";